// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 30vh;\n}\n\n.login .form-control {\n  width: 15rem;\n}\n\n.alert {\n  text-align: center;\n}\n\n.forgot-text {\n  margin-top: 10px;\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
